import { useDispatch, useSelector } from 'react-redux'
import { IoTrash } from 'react-icons/io5'
import colors from 'tailwindcss/colors'

import { useModal } from '@/hooks/useModal'
import { useToast } from '@/hooks/useToast'
import { api } from '@/services/api'
import { ReduxProps } from '@/storage'
import {
  LicensesProps,
  handleSetLicenses,
} from '@/storage/modules/licenses/reducer'
import { LicenseResponseProps } from '@/types/licensesProps'

import { EmptyState } from '../EmptyState'
import { FormLicense } from '../FormLicense'

export function Licenses() {
  const { openModal } = useModal()
  const { showToast } = useToast()
  const dispatch = useDispatch()

  const { licenses } = useSelector<ReduxProps, LicensesProps>(
    (state) => state.licenses,
  )

  const handleRemoveLicense = async (licenseId: string) => {
    try {
      await api.delete(`/licenses/${licenseId}`)

      const response = await api
        .get('/licenses')
        .then((res) => res.data.data as LicenseResponseProps[])

      dispatch(handleSetLicenses({ licenses: response }))

      showToast('License removed successfully', {
        type: 'success',
        theme: 'light',
      })
    } catch (error) {
      showToast('Error removing license', {
        type: 'error',
        theme: 'light',
      })
    }
  }

  return (
    <div>
      {licenses.length === 0 && (
        <EmptyState
          title="No licenses yet"
          description="Create the first license to use it in the music catalog."
        />
      )}
      {licenses.map((license) => (
        <div key={license.id} className="relative mt-8">
          <button
            title="Remove"
            className="absolute -right-1.5 -top-1.5 z-10 flex h-8 w-8 items-center justify-center rounded-full border border-red-600 bg-red-600 shadow-sm transition hover:bg-red-700"
            onClick={() => {
              openModal({
                textConfirm: 'Delete',
                description: 'Do you really want to delete the license?',
                title: 'Attention',
                confirm() {
                  handleRemoveLicense(license.id)
                },
              })
            }}
          >
            <IoTrash size={14} color={colors.white} />
          </button>

          <button
            className="bg-white rounded-2xl p-7 top-5 flex gap-4 justify-between items-center border hover:border-gray-300 w-full text-left"
            onClick={() => {
              openModal({
                small: true,
                children: <FormLicense isExist={license} />,
              })
            }}
          >
            <div>
              <p className="font-semibold text-gray-500">{license.title}</p>
              <p className="text-sm text-gray-400 mt-1 break-all">
                {license.url}
              </p>
            </div>
          </button>
        </div>
      ))}
    </div>
  )
}
